import { z } from 'zod'

import { ConnectReferralCodeArgs } from './useConnectReferralCode'
import { spark2ApiUrl } from '@/config/consts'

export async function verifyReferralCode({ referralCode, account }: ConnectReferralCodeArgs): Promise<void> {
  const res = await fetch(`${spark2ApiUrl}/referrals/verify_referral/${referralCode}/${account}/`)
  if (!res.ok && res.status !== 400) {
    throw new Error('Failed to verify invite code')
  }

  const parsedResult = baDataResponseSchema.parse(await res.json())

  if (parsedResult.reason) {
    throw new Error(failedVerificationReasonToError[parsedResult.reason])
  }
}

export const baDataResponseSchema = z.object({
  can_connect: z.boolean(),
  reason: z.enum(['invalid_invite', 'already_connected']).nullable(),
})

type FailedVerificationReason = 'invalid_invite' | 'already_connected'
const failedVerificationReasonToError: Record<FailedVerificationReason, string> = {
  already_connected: 'Another invite code already in use',
  invalid_invite: 'Invalid invite code',
}
